import { EMPTY_ENTITY, type EntityType, type Route, type RouteEntity } from './types';

/** Normalize legacy hashes to canonical `#/…` form. */
export function normalizeHash(raw: string): string {
	const h = raw.trim();
	if (!h || h === ' ' || h === '#') return '#/';
	return h.startsWith('#') ? h : `#${h}`;
}

export function parseHash(hash: string): Route {
	const h = normalizeHash(hash);

	let m: RegExpExecArray | null;
	if ((m = /^#\/unit\/(\d+)(?:\/([a-z-]+)(?:\/(\d+))?)?$/.exec(h))) {
		const type = (m[2] as EntityType) || null;
		const entity: RouteEntity | null = type
			? { type, id: m[3] != null ? Number(m[3]) : null }
			: null;
		return { name: 'unit', unitId: Number(m[1]), entity };
	}
	if ((m = /^#\/project\/(\d+)$/.exec(h))) {
		return { name: 'project', projectId: Number(m[1]) };
	}
	if (/^#\/guide$/.test(h)) return { name: 'guide' };
	if (/^#\/admin\/users$/.test(h)) return { name: 'admin-users' };
	return { name: 'dashboard' };
}

export function serializeHash(route: Route): string {
	if (route.name === 'guide') return '#/guide';
	if (route.name === 'admin-users') return '#/admin/users';
	if (route.name === 'project') return `#/project/${route.projectId}`;
	if (route.name === 'unit') {
		const e = route.entity;
		if (e?.type) {
			return e.id != null
				? `#/unit/${route.unitId}/${e.type}/${e.id}`
				: `#/unit/${route.unitId}/${e.type}`;
		}
		return `#/unit/${route.unitId}`;
	}
	return '#/';
}

export function routesEqual(a: Route, b: Route): boolean {
	return serializeHash(a) === serializeHash(b);
}

export function projectIdFromRoute(route: Route, unitProjectId: number | null): number | null {
	if (route.name === 'project') return route.projectId;
	if (route.name === 'unit') return unitProjectId;
	return null;
}

export function unitIdFromRoute(route: Route): number | null {
	return route.name === 'unit' ? route.unitId : null;
}
